"use client";

import React from "react";
const clients = [{
  id: 1,
  name: "TechFlow Systems",
  logo: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/047.png?v=xrgguaw3r5g"
}, {
  id: 2,
  name: "DataCore Solutions",
  logo: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/040.png?v=8pwa58e6i3i"
}, {
  id: 3,
  name: "CloudScale Networks",
  logo: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/042.png?v=v65y731lw9d"
}, {
  id: 4,
  name: "CyberGuard Pro",
  logo: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/047.png?v=56iapt1nstd"
}, {
  id: 5,
  name: "LogicGate AI",
  logo: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/041.png?v=27jpvui2dk8"
}, {
  id: 6,
  name: "InfraStructure X",
  logo: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/046.png?v=7u2q3bsfjy4"
}, {
  id: 7,
  name: "Quantum Logic",
  logo: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/048.png?v=jgge61ot5xe"
}, {
  id: 8,
  name: "Vector Dynamics",
  logo: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/049.png?v=qubmcs5b26s"
}, {
  id: 9,
  name: "TechFlow Systems Alt",
  logo: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/044.png?v=ldljxjorlbf"
}, {
  id: 10,
  name: "DataCore Solutions Alt",
  logo: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/045.png?v=12vu6iveqzof"
}, {
  id: 11,
  name: "CloudScale Networks Alt",
  logo: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/042.png?v=fp9qy1g2h3"
}];
export default function OurValuedClients() {
  const duplicatedClients = [...clients, ...clients];
  return <section data-section-id="221443" id="global-alliances" className="bg-background text-foreground py-24 light overflow-hidden">
      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .animate-marquee {
            animation: marquee 30s linear infinite;
          }
        `
    }} />
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <h2 className="mb-16 text-center font-default text-4xl font-bold uppercase tracking-widest text-foreground md:text-5xl">
          Global Alliances
        </h2>

        <div className="relative w-full overflow-hidden">
          <div className="flex w-screen animate-marquee items-center gap-12 py-4 relative left-1/2 -translate-x-1/2">
            {duplicatedClients.map((client, i) => <div key={`${client.id}-${i}`} data-index={i} className="flex shrink-0 items-center justify-center px-4">
                <img src={client.logo} data-wvc-srcset={`${client.logo}-wvc-srcset`} data-wvc-sizes={`${client.logo}-wvc-sizes`} alt={client.name} loading="lazy" className="h-12 w-auto object-contain opacity-50 grayscale transition-all duration-400 ease-out hover:opacity-100 hover:grayscale-0" />
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}